<template>
    <modal
        name="visibilidad-reducida"
        transition="pop-out"
        :width="800"
        height="auto"
        scrollable
        id="visibilidad-reducida"
        :adaptive="true"
        :click-to-close="false"
    >
        <div class="card m-0">
            <div class="card-header">
                <div class="row">
                    <div class="col-10">
                        <h2 class="text-dark">{{ $t(clave(tipo === 'butaca' ? 'butaca' : 'sector')) }}</h2>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <h3 class="text-danger">{{ $t(clave(tipo === 'butaca' ? 'no_garantizamos_butaca' : 'no_garantizamos')) }}</h3>
                <div v-if="zona?.texto_visibilidad_reducida" v-html="zona.texto_visibilidad_reducida"></div>
                <p class="mt-4 mb-0">
                    <small>{{ $t(clave('eximo_responsabilidad')) }}</small>
                </p>
            </div>
            <div class="card-footer text-right">
                <slot name="footer">
                    <Button type="button" name="button" @click.prevent="aceptar()">{{ $t('visibilidad_reducida.aceptar') }}</Button>
                </slot>
            </div>
        </div>
    </modal>
</template>

<script>
    import { claveVisibilidad } from '@/utils/visibilidadReducida';

    export default {
        props: {
            tipo: {
                type: String,
                default: 'sector'
            },
            zona: {
                type: Object
            },
            sesion_id: {
                default: null
            }
        },
        computed: {
            sesionIdEfectiva() {
                if (this.sesion_id !== null && this.sesion_id !== undefined) {
                    return this.sesion_id;
                }

                return this.$route?.params?.sesion_id ?? null;
            }
        },
        methods: {
            clave(nombre) {
                return claveVisibilidad(`visibilidad_reducida.${nombre}`, this.sesionIdEfectiva, clave => this.$te(clave));
            },
            aceptar() {
                this.$emit('aceptar');
            },
        },
    }
</script>
